import { ILogin, ILoginResult, IRefreshTokenResult, IUserModel } from "../abstraction";
import { AppLabels } from "../core/AppLabels";
import { barCodeSvc, dispatcher, resourceManager, soundSvc } from "../Karma";

// Gestion de tout ce qui concerne la s�curit� (login/logout/gestion des droits/roles...)
export class Security {
	constructor(loginProvider: ILogin) {
		console.debug("Security service initializing ");

		let previousLogin = sessionStorage.getItem('user');

		if (previousLogin != undefined) {
			this._currentUser = JSON.parse(previousLogin);
			console.debug("Security previous log detected " + this.currentUser);
		}
		this._provider = loginProvider;
	}

	private _provider: ILogin;
	private _currentUser?: IUserModel = null;
	public inactivityOn: boolean = true;			    // Flag qui active la d�connexion automatique
	private _inactivityTimeOut: number;			// Temps avant d�connexion auto (en minutes)

	public get currentUser(): IUserModel {
		return this._currentUser
	}

	public async Logout(): Promise<boolean> {
		return new Promise<boolean>(async (resolve, reject) => {
			try {
				barCodeSvc.Stop();
				clearTimeout(this.tokenTimeOutHdlr);
				clearTimeout(this.sessionTimeOutHdlr);

				this._currentUser = null;
				this._provider.Logout().then(() => {
					console.log("Logout OK");
					this._currentUser = null;
					sessionStorage.clear();
					resolve(true);
				}).catch((err: any) => {
					console.log("Logout KO");
					console.log(err);
				});
			}
			catch (err) {
				reject(err)
			}
		});
	}









	public isAuth(): boolean {
		return (this._currentUser !== null);
	}

	public async RestoreSession() {
		console.log("Security - RestoreSession");

		let previousId = this._currentUser.id;
		let result = await dispatcher.GetUserInfos(this._currentUser.id);
		result.user.id = previousId;
		this._currentUser = result.user;

		this.setTokenTimeOutWarning(result.tokenExpiration);
		this._inactivityTimeOut = result.inactivityTimeout;
		this.setSessionTimeOutWarning();

		barCodeSvc.Start();
		barCodeSvc.Prefix = this._currentUser.CBPrefix;
		barCodeSvc.Suffix = this._currentUser.CBSuffix;
		dispatcher.isVirtualKeyboardActive = this._currentUser.inputMode == 2;

		resourceManager.imgBank = result.images;
		soundSvc.soundBank = result.sounds;
		soundSvc.DefautSound_Error = result.defaultSound_Error;
		soundSvc.DefautSound_Ok = result.defaultSound_Success;
		soundSvc.DefautSound_Warning = result.defaultSound_Warning;

		for (let i = 0; i < result.labels.length; i++)
			AppLabels[result.labels[i].key] = result.labels[i].value;

	}

	public async Login(login: string, password: string): Promise<ILoginResult> {
		return new Promise<ILoginResult>(async (resolve, reject) => {
			try {
				this._currentUser = null;
				this._provider.Login(login, password)
					.then((result) => {
						this._currentUser = result.user;
						this.setTokenTimeOutWarning(result.tokenExpiration);

						this._inactivityTimeOut = result.inactivityTimeout;
						this.setSessionTimeOutWarning();


						barCodeSvc.Start();
						barCodeSvc.Prefix = this._currentUser.CBPrefix;
						barCodeSvc.Suffix = this._currentUser.CBSuffix;
						dispatcher.isVirtualKeyboardActive = this._currentUser.inputMode == 2;

						sessionStorage.setItem('user', JSON.stringify(this._currentUser));

						// TODO: EVOL
						// Pour �viter une d�pendance envers resourcemanager & soundSvc, il faudrait plut�t d�clencher un �v�nement
						// ce dernier serait alors intercept� et trait� � un plus haut niveau. 
						resourceManager.imgBank = result.images;

						soundSvc.soundBank = result.sounds;
						soundSvc.DefautSound_Error = result.defaultSound_Error;
						soundSvc.DefautSound_Ok = result.defaultSound_Success;
						soundSvc.DefautSound_Warning = result.defaultSound_Warning;

						result.labels.map(x => {
							AppLabels[x.key] = x.value;
						});

						resolve(result)
					})
					.catch((err) => {
						console.log(err);
						reject(err)
					});
			}
			catch (err) {
				reject(err)
			}
		});
	}

	public async RefreshAuthToken(): Promise<IRefreshTokenResult> {
		console.log("Security - RefreshAuthToken");
		return new Promise<IRefreshTokenResult>(async (resolve, reject) => {
			this._provider.RefreshAuthToken()
				.then((result) => {
					this._currentUser.authString = result.newToken;

					this.setTokenTimeOutWarning(result.sessionExpiration);
					this.setSessionTimeOutWarning();

					sessionStorage.setItem('user', JSON.stringify(this._currentUser));
					resolve(result)
				})
				.catch((err) => {
					console.log(err);
					this.Logout();
					reject(err)
				});
		});
	}


	// dur�e en secondes
	private setTokenTimeOutWarning(duration: number): void {
		clearTimeout(this.tokenTimeOutHdlr);

		// On consid�re que s'il reste moins d'1 mn, on ne pr�vient pas
		if (duration < 60) return;

		// 20 secondes avant l'expiration, on affiche une alerte
		this.tokenTimeOutHdlr = setTimeout(() => {
			console.log("Token is reaching end of life")
			this._provider.TokenWillExpire();
		}, (duration - 20) * 1000);
	}
	private tokenTimeOutHdlr: any;


	// dur�e en minutes
	public setSessionTimeOutWarning(): void {
		clearTimeout(this.sessionTimeOutHdlr);

		if (this.currentUser == null || this.inactivityOn == false) return;

		if (this._inactivityTimeOut == 0) this._inactivityTimeOut = 15;

		this.sessionTimeOutHdlr = setTimeout(() => {
			this._provider.SessionWillExpire();
		}, (this._inactivityTimeOut * 60) * 1000);
	}
	private sessionTimeOutHdlr: any;

}



